/**
 * APP-SPECIFIC ADAPTER — hand-written, NOT synced. Do not add logic here.
 *
 * Binds this app's lookups endpoint to the shared AddressComplete core
 * (src/shared/lib/addressComplete). patient-ui uses the bridge path
 * `/api/bridge/config/lookups`; physician-ui uses `/api/config/lookups`.
 * DO NOT unify the endpoints — the split is deliberate and pinned by
 * src/lib/addressLookups.test.ts.
 */
import { makeLookupKeyFetcher } from "../shared/lib/lookupsKey";

export * from "../shared/lib/addressComplete";

/** Fetch (and cache) the AddressComplete key from the bridge. "" = disabled. */
export const getAddressCompleteKey = makeLookupKeyFetcher(
  "/api/bridge/config/lookups",
  "addresscomplete_key",
);
